module.exports = __webpack_public_path__ + "img/login-img.b393c188.png";